import { v4 as uuidv4 } from 'uuid';
import { isValidDate, isValidExtension, excelFileChosen } from './Invoice';

const validate = (payload) => {

    let channelId = payload.default_channel && typeof payload.default_channel === 'object' && payload.default_channel.channel_id
        ? payload.default_channel.channel_id
        : payload.default_channel;

    let accountingDate = payload.screen_data.accounting_date_config === 'configurated'
        ? payload.screen_data.default_accounting_date
        : payload.screen_data.accounting_date_config;

    return { channelId, accountingDate };
}

export function get_upload_config(payload){

    const { channelId, accountingDate } = validate(payload);

    let info = {
      'kind': payload.screen_data.kind,
      'default_accounting_date': accountingDate,
      'split': payload.split,
      'activity': payload.default_activity,
      'project_id': payload.selected_project,
      'channel_id': channelId,
      'delegation_id': payload.selected_delegation,
      'section_id':payload.selected_section,
      'department_id':payload.selected_department
    }

    if (payload.excelFileChosen){
      info['excel_kind'] = payload.screen_data.excel_kind
    }

    if (payload.got_feature('feature_fecha_registro') && payload.currentCompany && payload.currentCompany.enable_fecha_sii){
      info['default_registro_date'] = payload.screen_data.registro_date_config=='configurated'?payload.screen_data.default_registro_date: payload.screen_data.registro_date_config
    }
    
    return info
}

export async function upload_files_to_s3(that, Auth, uuid_getter=uuidv4){
    let files_info = []
    const cc = await Auth.currentCredentials()
    for (let i = 0; i < that.screen_data.files.length; i++) {
        const file_name = that.screen_data.files[i].name
        const extension = file_name.split('.').pop();
        const uuid = uuid_getter();
        const s3_key = `private/${cc.identityId}/pdfs/${uuid}.${extension}`
        
        that.screen_data.uploading_file = file_name;
        files_info.push({name: file_name, 
                        size: that.screen_data.files[i].size, 
                        uuid: uuid,
                        extension: extension,
                        s3_key: s3_key})
        that.screen_data.uploading_percent = i * 100 / that.screen_data.files.length;
        that.uploading_percent2 = 0;
        await that.upload_file_to_s3(s3_key, that.screen_data.files[i])
        that.screen_data.uploaded_files[that.screen_data.uploading_file] = true;
    }
    return files_info
}

export function get_config_errors(that){
    that.screen_data.empty_kind=false
    that.screen_data.empty_actividad=false  
    that.screen_data.invalid_default_accounting_date=false
    that.screen_data.invalid_default_registro_date=false
    if (!that.screen_data.kind) {
      that.screen_data.empty_kind=true
      return 'Debe seleccionar un tipo de documento';
    }
    if (that.currentCompany.configuration && that.currentCompany.companydb_type.params.show && that.currentCompany.companydb_type.params.show.includes('actividad') && !that.default_activity){
      that.screen_data.empty_actividad=true  
      return 'Debe seleccionar una actividad';
    }
    if (that.screen_data.accounting_date_config === 'configurated' && !isValidDate(that.screen_data.default_accounting_date)) {
      that.screen_data.invalid_default_accounting_date=true
      return 'La fecha contable no es válida';
    } 
    if (that.got_feature('feature_fecha_registro') && that.currentCompany && that.currentCompany.enable_fecha_sii && that.screen_data.registro_date_config === 'configurated' && !isValidDate(that.screen_data.default_registro_date)) {
      that.screen_data.invalid_default_registro_date=true
      return 'La fecha de registro no es válida';
    } 
    for (let i = 0; i < that.screen_data.files.length; i++) {
        const ext = that.screen_data.files[i].name.split('.').pop()
        if(!isValidExtension(ext, that.userData)){
            return 'El archivo '+ that.screen_data.files[i].name + ' no tiene una extensión soportada';
        }
      }
      if(excelFileChosen(that.screen_data.files, that.userData) && that.screen_data.files.length>1 && that.screen_data.excel_kind == 'excel_list'){
        return 'No se pueden subir varios archivos de excel a la vez';
      }
    return null
  }